import { Translations } from './translations.model';

export const nl: Translations = {
    app: {
        name: 'NS-account beheer KS en balie',
        logout: 'Uitloggen',
    },
    unauthenticated: {
        title: 'U bent uitgelogd',
        description: 'Uw sessie is succesvol beeindigd. U kunt opnieuw inloggen wanneer u verder wilt werken.',
        primaryAction: 'Opnieuw inloggen',
    },
    search: {
        title: 'Gebruikers',
        searchBy: 'Zoek op',
        searchTerm: 'Zoekterm',
        emailAddress: 'E-mailadres',
        nsrNumber: 'NSR-nummer',
        searchButton: 'Zoeken',
        clearButton: 'Leegmaken',
        placeholder: 'jan.dejong@voorbeeld.nl',
        searching: 'Bezig met zoeken...',
        accountDeletedMessage: 'Account is succesvol verwijderd.',
        accountInvitedMessage: 'Uitnodiging is succesvol verzonden.',
        accountBlockedMessage: 'Account is succesvol geblokkeerd.',
        accountUnblockedMessage: 'Account is succesvol gedeblokkeerd.',
        accountBlockedErrorMessage: 'Blokkeren van account mislukt. Probeer het opnieuw.',
        accountUnblockedErrorMessage: 'Deblokkeren van account mislukt. Probeer het opnieuw.',
        emailVerificationRequestedMessage: 'Verificatie-e-mail is succesvol aangevraagd.',
        businessActivationEmailResentMessage: 'Activatie-e-mail is succesvol opnieuw verzonden.',
        personActionFailed: 'Er is iets misgegaan bij het uitvoeren van deze actie. Probeer het opnieuw.',
        accountNotFoundTitle: 'Account niet gevonden',
        accountNotFoundMessage: 'Geen account gevonden voor de opgegeven zoekwaarde. Controleer het e-mailadres of NSR-nummer en probeer het opnieuw.',
        invalidEmail: 'Voer een geldig e-mailadres in.',
        emptySearchTermMessage: 'Voer een zoekterm in.',
        genericSearchErrorMessage: 'Er is iets misgegaan tijdens het zoeken. Probeer het opnieuw.',
    },
    notFound: {
        notFoundMessage: 'De pagina die u probeert te bereiken bestaat niet.',
        title: 'Pagina niet gevonden',
        backToHomeButton: 'Terug naar startpagina',
    },
    userDetails: {
        title: 'Gebruikersdetails',
        backButton: 'Terug naar zoekpagina',
        profileTitle: 'Profiel',
        id: 'ID',
        emailAddress: 'E-mailadres',
        verified: 'geverifieerd',
        emailVerification: {
            verified: 'Geverifieerd',
            notVerified: 'Niet geverifieerd',
        },
        nsr: 'NSR',
        copyButton: 'Kopieer',
        copiedButton: 'Gekopieerd',
        editButton: 'Wijzigen',
        saveButton: 'Opslaan',
        cancelButton: 'Annuleren',
        nsrCopiedMessage: 'NSR is naar het klembord gekopieerd.',
        nsrUpdatedMessage: 'NSR is bijgewerkt in Identity Provider.',
        nsrUpdateFailedMessage: 'Bijwerken van NSR mislukt. Probeer het opnieuw.',
        copyFailedMessage: 'Kopieren van NSR mislukt. Kopieer deze handmatig.',
        loadFailedMessage: 'Laden van gebruikersgegevens mislukt. Probeer het opnieuw.',
        changeButton: 'Wijzigen',
        accountTitle: 'Account',
        accountCreated: 'Account aangemaakt',
        accountStatus: 'Account status',
        actionsButton: 'Acties',
        latestEvents: {
            title: 'Recente gebeurtenissen',
            columns: {
                date: 'Datum',
                event: 'Gebeurtenis',
                application: 'Applicatie',
                username: 'Gebruikersnaam',
                reason: 'Reden',
                browser: 'Browser',
            },
            nextPageAriaLabel: 'Ga naar volgende pagina',
        },
        dropdown: {
            deleteAccount: 'Mijn NS - Account verwijderen',
            verifyEmailAddress: 'Mijn NS - E-mailadres verifiëren',
            requestNewVerificationEmail: 'Mijn NS - Vraag nieuwe verificatie-e-mail aan',
            inviteConsumer: 'Mijn NS - Consument uitnodigen',
            blockAccount: 'Mijn NS - Account blokkeren',
            unblockAccount: 'Mijn NS - Account deblokkeren',
            businessRequestActivationEmail: 'Mijn NS Zakelijk - Verstuur opnieuw activiseringslink',
        },
        deleteWarning: {
            title: 'Veiligheidsinstructies voor het verwijderen van accounts',
            message: 'Weet u dat het verwijderen van een account permanente gevolgen heeft?',
            bullets: [
                'Het verwijderen van dit account verwijdert permanent de toegang van de gebruiker en alle bijbehorende accountgegevens uit NS Account Management.',
                'Na verwijdering kan dit account niet meer worden gebruikt om toegang te krijgen tot NS-diensten of interne applicaties, en kan het niet worden hersteld.',
                'Verwijder alleen accounts in overeenstemming met het NS-beleid en uw lokale procedures voor beveiliging, privacy en compliance.',
                'Als u niet zeker weet of dit account verwijderd mag worden, stop dan nu en raadpleeg uw teamleider of de NS-ondersteuningsprocedures.',
            ],
            acknowledgementLabel: 'Ik heb de veiligheidsinstructies voor het verwijderen van dit account gelezen en begrepen.',
            confirmButton: 'Doorgaan',
            cancelButton: 'Annuleren'
        },
        deleteConfirm: {
            title: 'Account verwijderen',
            message: 'Weet u zeker dat u het account met het e-mailadres {{email}} wilt verwijderen?',
            warning: 'Deze actie kan niet ongedaan worden gemaakt.',
            confirmButton: 'Verwijderen',
            cancelButton: 'Annuleren',
        },
        organisationsTitle: 'Organisaties',
        organisations: {
            name: 'Naam',
            bpid: 'Debiteurennummer',
            nsr: 'NSR',
        }
    },
    unauthorized: {
        title: 'U heeft geen toegang tot deze toepassing',
        description: 'Uw account is aangemeld, maar u heeft geen toegang tot deze werkruimte. Neem contact op met uw beheerders.',
        primaryAction: 'Afmelden en een ander account proberen',
        secondaryAction: 'Terug naar login',
    },
};
